module.exports = __webpack_public_path__ + "img/hyj8.d904ecc9.png";